import { render, staticRenderFns } from "./CreateTagDialog.vue?vue&type=template&id=582f43b0&scoped=true"
import script from "./CreateTagDialog.vue?vue&type=script&lang=js"
export * from "./CreateTagDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateTagDialog.vue?vue&type=style&index=0&id=582f43b0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582f43b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('582f43b0')) {
      api.createRecord('582f43b0', component.options)
    } else {
      api.reload('582f43b0', component.options)
    }
    module.hot.accept("./CreateTagDialog.vue?vue&type=template&id=582f43b0&scoped=true", function () {
      api.rerender('582f43b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/chat/tag/dialog/CreateTagDialog.vue"
export default component.exports